<template>
  <v-dialog :value="value" max-width="480px" @input="$emit('input', $event)">
    <v-card class="pa-2">
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="text-subtitle-1 font-weight-bold">
          {{ initialUrl ? 'Изменить ссылку' : 'Добавить ссылку' }}
        </span>
        <v-btn icon small @click="$emit('input', false)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="text-caption grey--text text--darken-1 mb-1">Ссылка на конференцию</div>
        <v-text-field
          v-model="url"
          placeholder="https://..."
          outlined
          dense
          hide-details
          autofocus
          @keydown.enter="save"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn block color="#483CB9" :dark="canSave" :loading="loading" :disabled="!canSave" @click="save">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Замена window.prompt для ссылки на конференцию подтверждённой записи.
export default {
  name: 'ConferenceLinkDialog',
  props: {
    value: { type: Boolean, default: false },
    initialUrl: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      url: this.initialUrl,
    };
  },
  computed: {
    canSave() {
      return Boolean(this.url.trim());
    },
  },
  watch: {
    // Диалог не пересоздаётся между открытиями — подставляем актуальную ссылку при каждом показе.
    value(isOpen) {
      if (isOpen) this.url = this.initialUrl || '';
    },
  },
  methods: {
    save() {
      if (!this.canSave) return;
      this.$emit('save', this.url.trim());
    },
  },
};
</script>
